"use client";

import { c as _c } from "react/compiler-runtime";
import { ThemeProvider } from "next-themes";
import { Toaster } from "@/components/ui/sonner";
import { useEffect, useState, ViewTransition } from "react";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
type ProvidersProps = {
  children: React.ReactNode;
};
function Providers(t0) {
  const $ = _c(5);
  const {
    children
  } = t0;
  const [client] = useState(_temp);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = [];
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  useEffect(_temp2, t1);
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <Toaster />;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== children || $[3] !== client) {
    t3 = <ViewTransition><ThemeProvider attribute="class" defaultTheme="system" enableSystem={true}><QueryClientProvider client={client}>{t2}{children}</QueryClientProvider></ThemeProvider></ViewTransition>;
    $[2] = children;
    $[3] = client;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  return t3;
}
function _temp2() {
  if ("serviceWorker" in navigator) {
    navigator.serviceWorker.register("/service-worker.js");
  }
}
function _temp() {
  return new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 60000
      }
    }
  });
}
export default Providers;